




import store from "@/general/store";
import commons from "@/common/store/modules/commons";
import { Vue, Prop, Component } from "vue-property-decorator";
import sanitizeHTML from "sanitize-html";

@Component({
  store: store
})
export default class TextSanitized extends Vue {
  @Prop({ type: String, required: true }) text!: string;
  get colorCode() {
    return commons.colorCode;
  }

  get sanitized() {
    const result = sanitizeHTML(this.getText, {
      allowedTags: sanitizeHTML.defaults.allowedTags.concat(["img"]),
      allowedAttributes: {
        "*": ["style"],
        a: ["href", "target"],
        img: ["src"]
      },
      selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
      ],
      // URL schemes we permit
      allowedSchemes: ["http", "https"],
      allowedSchemesByTag: { img: ["http", "https", "data"] },
      allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
      transformTags: {
        a: sanitizeHTML.simpleTransform("a", {
          style: `color: ${this.colorCode}`
        }),
        em: sanitizeHTML.simpleTransform("em", {
          style: "font-style: italic"
        }),
        i: sanitizeHTML.simpleTransform("i", {
          style: "font-style: italic"
        })
      }
    });
    return result;
  }

  get getText() {
    return this.text;
  }
}
